import React, { useEffect, useState } from "react";
import {
  function_TODOS_AsistenciaEnLinea_Mensajes_EnviarMensaje,
  function_TODOS_AsistenciaEnLinea_Mensajes_EnviarRespuesta,
  function_TODOS_AsistenciaEnLinea_Mensajes_ListarChats,
  function_TODOS_AsistenciaEnLinea_Mensajes_ListarDeCliente,
  function_TODOS_AsistenciaEnLinea_Mensajes_ListarDePersona,
  function_TODOS_AsistenciaEnLinea_Mensajes_ListarDeProveedor
} from "neftis7_apicaller/src/funciones/TODOS_AsistenciaEnLinea_Mensajes";
import { PaginaCarga } from "../../Componentes/Compuestos/Paginas/PaginaCarga"

const AsistenciaEnLinea_Operadores = () => {
  const [conversaciones, setConversaciones] = useState([]);
  const [mensajes, setMensajes] = useState([]);
  const [clienteActivo, setClienteActivo] = useState(null);
  const [ultimoMensajeActivo, setUltimoMensajeActivo] = useState(null);
  const [nuevoMensaje, setNuevoMensaje] = useState("");

  useEffect(() => {
    cargarConversaciones();
  }, []);

  const cargarConversaciones = async () => {
    try {
      const res = await function_TODOS_AsistenciaEnLinea_Mensajes_ListarChats("todo");

      const conversacionesUnificadas = res.data.map(conv => ({
        ...conv,
        IdEntidad: conv.IdEntidad, 
        Canal: conv.Canal          
      }));

      console.log(res)
      console.log(conversacionesUnificadas)

      setConversaciones(conversacionesUnificadas);
    } catch (err) {
      console.error("Error cargando conversaciones:", err);
    }
  };

  const cargarMensajes = async (canal, IdEntidad, IdMensaje) => {
    try {
      let res;
      if (canal === "cliente") {
        res = await function_TODOS_AsistenciaEnLinea_Mensajes_ListarDeCliente(IdEntidad);
      }
      if (canal === "proveedor") {
        res = await function_TODOS_AsistenciaEnLinea_Mensajes_ListarDeProveedor(IdEntidad);
      }
      if (canal === "persona") {
        res = await function_TODOS_AsistenciaEnLinea_Mensajes_ListarDePersona(IdEntidad);
      }

      setMensajes(res.data);
      setClienteActivo({ canal, id: IdEntidad });
      setUltimoMensajeActivo(IdMensaje);

      setTimeout(() => {
        const cont = document.getElementById("chat-container");
        if (cont) cont.scrollTop = cont.scrollHeight;
      }, 100);
    } catch (err) {
      console.error("Error cargando mensajes:", err);
    }
  };

  const enviarMensaje = async () => {
    if (!nuevoMensaje.trim()) return;
    try {

      const Mensaje = {
        CodigoCompania: localStorage.getItem("CodigoCompania"),
        CodigoEmpresa: localStorage.getItem("CodigoEmpresa"),
        CodigoPlanta: localStorage.getItem("CodigoPlanta"),
        IdMensaje: ultimoMensajeActivo,
        Texto: nuevoMensaje,
        IdPersonaOperador: localStorage.getItem("IdPersona"),
        EsGeneracionAutomatica: false
      }
      console.log(Mensaje)
      await function_TODOS_AsistenciaEnLinea_Mensajes_EnviarRespuesta(Mensaje)
      setNuevoMensaje("");
      cargarMensajes(clienteActivo);
    } catch (err) {
      console.error("Error enviando mensaje:", err);
    }
  };

  const getColorByRemitente = (remitente) => {
    switch (remitente) {
      case "cliente": return '#43a047';
      case "proveedor": return "#ffe066";
      case "persona": return "#e1d5e7";
      case "operador": return "#007bff";
      default: return "#f8f9fa";
    }
  };

  const getTextColor = (remitente) => {
    return remitente === "operador" ? "white" : "black";
  };

  return (
    <PaginaCarga
      Titulo="ASISTENCIA EN LINEA - OPERADORES"
    >
      <div style={{ display: 'flex', height: '80vh', border: '1px solid #ccc', borderRadius: 8 }}>
        {/* Lista de conversaciones */}
        <div style={{ width: 300, borderRight: '1px solid #ddd', overflowY: 'auto' }}>
          <div style={{ backgroundColor: '#007bff', color: 'white', padding: 10, fontWeight: 'bold' }}>📋 Conversaciones</div>
          {conversaciones.map((conv) => (
            <div
              key={`${conv.Canal}-${conv.IdEntidad}`}
              onClick={() => cargarMensajes(conv.Canal, conv.IdEntidad, conv.IdMensaje)}
              style={{
                padding: 10,
                cursor: 'pointer',
                backgroundColor:
                  clienteActivo?.id === conv.IdEntidad && clienteActivo?.canal === conv.Canal
                    ? getColorByRemitente(conv.Canal)
                    : 'gray',
                borderBottom: '1px solid #eee'
              }}
            >
              <strong>{conv.Canal.toUpperCase()} - {conv.RazonSocial}</strong><br />
              <small>{conv.UltimoMensaje}</small>
            </div>
          ))}
        </div>

        {/* Panel de chat */}
        <div style={{ flex: 1, display: 'flex', flexDirection: 'column' }}>
          <div style={{ backgroundColor: '#007bff', padding: 10, fontWeight: 'bold' }}>
            {clienteActivo ? `Chat con ${clienteActivo.canal.toUpperCase()} ID ${clienteActivo.id}` : 'Seleccioná una conversación'}
          </div>

          <div id="chat-container" style={{ flex: 1, padding: 15, overflowY: 'auto', backgroundColor: '#f9f9f9' }}>
            {mensajes.map((msg, idx) => (
              <div key={idx} style={{ display: 'flex', justifyContent: msg.Remitente === 'operador' ? 'flex-end' : 'flex-start', marginBottom: 10 }}>
                <div style={{
                  maxWidth: '70%',
                  padding: '8px 12px',
                  borderRadius: 12,
                  backgroundColor: getColorByRemitente(msg.Remitente),
                  color: getTextColor(msg.Remitente),
                  fontSize: '0.9rem'
                }}>
                  {msg.Texto}
                </div>
              </div>
            ))}
          </div>

          {clienteActivo && (
            <div style={{ padding: 10, borderTop: '1px solid #ddd', backgroundColor: 'white' }}>
              <input
                type="text"
                value={nuevoMensaje}
                placeholder="Escribí una respuesta..."
                onChange={e => setNuevoMensaje(e.target.value)}
                onKeyDown={e => e.key === 'Enter' && enviarMensaje()}
                style={{
                  width: '100%',
                  padding: '8px 12px',
                  borderRadius: 8,
                  border: '1px solid #ccc',
                  outline: 'none'
                }}
              />
            </div>
          )}
        </div>
      </div>
    </PaginaCarga>
  );
};

export default AsistenciaEnLinea_Operadores;